const hideexpertiseoptions = (vueObj) => {
  vueObj.aoe = false;
};

const hideskillOptions = (vueObj) => {
  vueObj.skilltag = false;
};

const tagValidatoraoe = (vueObj, tag) => {
  return !vueObj.aoeoptiontags.some(
    (aoe) => aoe.toLowerCase() === tag.toLowerCase()
  );
};

const tagValidatorskill = (vueObj, tag) => {
  // let skills = vueObj.skilloptionstag.map((skill) => skill.toLowerCase());
  // return !skills.includes(tag.toLowerCase());
  return !vueObj.skilloptionstag.some(
    (skill) => skill.toLowerCase() === tag.toLowerCase()
  );
};

const isNumberValid = (vueObj) => {
  let regex = /^\d{7,10}$/;
  vueObj.phoneValid = regex.test(vueObj.panel.phoneNumber);
};

const expertisefunction = (vueObj) => {
  vueObj.aoe = !vueObj.aoe;
  vueObj.$forceUpdate();
};

const skillfunction = (vueObj) => {
  vueObj.skilltag = !vueObj.skilltag;
  vueObj.$forceUpdate();
};

const convertToLowerCase = (event, vueObj) => {
  const input = event.target;
  const start = input.selectionStart;
  const end = input.selectionEnd;
  vueObj.panel.email = input.value.toLowerCase();
  vueObj.$nextTick(() => {
    input.setSelectionRange(start, end);
  });
};

const clearpaneldata = (vueObj) => {
  vueObj.panel = {
    aoearray: [],
    panelID: "",
    skillarray: [],
    name: "",
    email: "",
    phoneNumber: "",
  };
};

module.exports = {
  hideexpertiseoptions,
  hideskillOptions,
  tagValidatoraoe,
  tagValidatorskill,
  isNumberValid,
  expertisefunction,
  skillfunction,
  clearpaneldata,
  convertToLowerCase,
};
